<template>
    <div>
        <div class="top-catalog-page__info info-top-catalog">
            <div class="select">
              <button type="button" class="select__btn">
                <img src="/img/icons/sorting.svg" alt="">
                <span>
                  {{ sortingText | trans }}
                </span>
              </button>
              <div class="select__body">
                <button type="button" class="select__item" @click="applySorting('isPopular')">
                  {{ 'By popularity' | trans }}
                </button>
                <button type="button" class="select__item" @click="applySorting('isNew')">
                  {{ 'New' | trans }}
                </button>
                <button type="button" class="select__item" @click="applySorting('lowestPrice')">
                  {{ 'Lowest price' | trans }}
                </button>
                <button type="button" class="select__item" @click="applySorting('highestPrice')">
                  {{ 'Highest price' | trans }}
                </button>
              </div>
            </div>
            <div class="info-top-catalog__right">
              {{ 'Found' | trans }} {{ numbering }} {{ 'objects' | trans }}
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Swiper, {Navigation, FreeMode} from "swiper";

export default {
    name: "PropertiesPageFilter",
    props: {
        numbering: {
            type: String,
            required: true
        },
        totalPropertiesNumber: {
            type: Number,
            required: true
        },
        propertyTypes: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            localSelectedPropertyTypes: [],
            allowToRedirectPage: false,
        };
    },
    computed: {
        ...mapGetters({
            selectedPropertyTypesFromStore: 'filtration/selectedPropertyTypes',
            selectedHighestPriceFromStore: 'filtration/selectedHighestPrice',
            selectedLowestPriceFromStore: 'filtration/selectedLowestPrice',
            selectedIsNewFromStore: 'filtration/selectedIsNew',
            selectedIsPopularFromStore: 'filtration/selectedIsPopular',
        }),
        isAllChecked: {
            get() {
                return this.localSelectedPropertyTypes.length === 0;
            },
            set(value) {
                if (value && this.localSelectedPropertyTypes.length !== 0) {
                    this.localSelectedPropertyTypes = [];
                }
            }
        },
        sortingText() {
            if (this.selectedIsPopularFromStore) {
                return 'By popularity';
            } else if (this.selectedHighestPriceFromStore) {
                return 'Highest price';
            } else if (this.selectedLowestPriceFromStore) {
                return 'Lowest price';
            } else if (this.selectedIsNewFromStore) {
                return 'New';
            }
            return 'By popularity';
        }
    },
    methods: {
        ...mapActions({
            updateSelectedPropertyTypes: 'filtration/updateSelectedPropertyTypes',
            redirectToPropertiesPage: 'filtration/redirectToPropertiesPage',
            resetFiltrationParams: 'filtration/resetFiltrationParams',
            saveToLocalStorage: 'filtration/saveToLocalStorage',
            setSelectedIsPopular: 'filtration/setSelectedIsPopular',
            setSelectedIsNew: 'filtration/setSelectedIsNew',
            setSelectedLowestPrice: 'filtration/setSelectedLowestPrice',
            setSelectedHighestPrice: 'filtration/setSelectedHighestPrice',
        }),
        updateSelectedTypes() {
            const params = {
                selectedPropertyTypes: this.localSelectedPropertyTypes
            };
            this.updateSelectedPropertyTypes(params);
            if (this.allowToRedirectPage) {
                this.redirectToPropertiesPage();
            }
        },
        applySorting(sortType) {
            this.setSelectedIsPopular({ selectedIsPopular: sortType === 'isPopular' });
            this.setSelectedIsNew({ selectedIsNew: sortType === 'isNew' });
            this.setSelectedLowestPrice({ selectedLowestPrice: sortType === 'lowestPrice' });
            this.setSelectedHighestPrice({ selectedHighestPrice: sortType === 'highestPrice' });
            this.redirectToPropertiesPage();
        },
    },
    watch: {
        localSelectedPropertyTypes: {
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    this.updateSelectedTypes();
                }
                this.allowToRedirectPage = true;
            },
            deep: true
        },
    },
    mounted() {
        let resetFilter = new URLSearchParams(window.location.search).get('resetFilter');
        if (resetFilter) {
            this.resetFiltrationParams();
            this.saveToLocalStorage();

            let propertyTypesIds = new URLSearchParams(window.location.search).get('propertyTypesIds');
            if (!propertyTypesIds) propertyTypesIds = '[]';

            propertyTypesIds = JSON.parse(propertyTypesIds).map(num => ({id: num}));
            this.updateSelectedPropertyTypes({
                'selectedPropertyTypes': propertyTypesIds
            });
        }

        this.localSelectedPropertyTypes = this.propertyTypes.filter(type =>
            this.selectedPropertyTypesFromStore.some(selectedType => selectedType.id === type.id)
        );
        if (!!this.propertyTypes && document.querySelector(".top-catalog-page__slider")) {
            new Swiper(".top-catalog-page__slider", {
                modules: [Navigation, FreeMode],
                observer: true,
                observeParents: true,
                speed: 800,
                spaceBetween: 8,
                watchOverflow: true,
                slidesPerView: "auto",
                breakpoints: {
                    768: {
                        navigation: {
                            prevEl: ".catalog-button_prev",
                            nextEl: ".catalog-button_next"
                        }
                    }
                },
              on: {
                reachEnd() {
                  document
                      .querySelector(".top-catalog-page__slider-wrap")
                      ?.classList.add("_end");
                },
                fromEdge() {
                  document
                      .querySelector(".top-catalog-page__slider-wrap")
                      ?.classList.remove("_end");
                }
              }
            });
        }
    },
}
</script>
